import { fetchCustomData, getData } from "../../services/fetch";
import { getRedirect } from "../../services/storage";
import { TokenType } from "./enum";
import { LeviasSwalCorrect } from "./Swal";
import { translations } from "../../services/localization";
import { REACT_APP_CODE_D_MEASUREMENT_API_URL, REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID } from "../../config";
import ReactGA from 'react-ga4';

var formatter = (decimalPlaces) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'JPY',
    maximumFractionDigits: decimalPlaces,
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export const getDecimalPlaces = amount => amount?.toString().includes('.') ? amount.toString().split('.')[1].length : 0;

export const formatMoney = (amount, unit = '¥') =>
    formatter(getDecimalPlaces(amount)).format(amount).replace(/^(\D+)/, unit + ' ');

export const formatNumber = amount => formatter(getDecimalPlaces(amount)).format(amount).replace(/^(\D+)/, '')
export const thousandSep = (val) => {
    return String(val).split("").reverse().join("")
        .replace(/(\d{3}\B)/g, "$1,")
        .split("").reverse().join("");
}

const gradientDuration = 500;

export const playGradientColor = e => {
    var x = e.target;
    x.classList.add("hover")
    setTimeout(() => x.classList.remove("hover"), gradientDuration);
}



export const addGradientColor = (e) => {
    removeAllGradientColor();
    var x = e.target;
    x.classList.add("hover");
}

export const addGradientColorById = (id) => {
    removeAllGradientColor();
    var x = document.getElementById(id);
    x.classList.add("hover");
}

export const removeAllGradientColor = e => {
    var classes = document.getElementsByClassName('gradient-text-hover');
    Array.from(classes).forEach((el) => {
        el.classList.remove("hover");
    });
}

export const removeGradientColor = (e) => {
    var x = e.target;
    setTimeout(() => x.classList.remove("hover"), gradientDuration);
}

export const copyToClipboard = (text, onConfirmCopy) => {
    navigator.clipboard.writeText(text);
    const commonlist = translations.common;
    return LeviasSwalCorrect.fire({
        title: translations.formatString(commonlist.copy_text),
    }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed && onConfirmCopy) {
            onConfirmCopy()
        }
    })
}

export const shorternAddress = (address) => `${address?.substring(0, 6)}...${address?.substring(address.length - 4, address.length)}`

export const UrlExists = async (url) => {
    var http = new XMLHttpRequest();
    http.open('HEAD', url, false);
    http.send();
    if (http.status != 404)
        return true;
    else
        return false;
}

export const formatPhoneNumberForDisplay = (phoneNumber, dialCode) => {
    var raw = dialCode ? phoneNumber.slice(dialCode.length) : phoneNumber;
    return raw;
}

export const getUniqueId = (prefix) => {
    const random = Math.floor(Math.random() * 10000000);
    const date = new Date().getTime();

    return `${prefix}_${random}_${date}`;
}

export const getArcanaDetail = async (token_type_id, token_id, preview = false) => {
    try {
        const url = `tokens/${TokenType.getContractAddress(token_type_id)}/${token_id}` + ((preview || Number(token_type_id) === Number(TokenType.Persona)) ? "?call_detail=false" : "?t=t") + '&nocache=' + new Date().getTime()
        var response = await getData(url);
        if (response.ok) {
            let token = response.data.response.token;
            return (Object.assign(token, {
                // ask_price: 0, // for testing purpose
                // bid_price: 0, // for testing purpose
                token_type_id,
                greenStar: token.greenStar + 1,
                feature: [],
                details: {
                    blockchain: 'ANICANA',
                    token_standard: 'ERC-721',
                    //mx_creator_bonus: '0.01 ANM',
                }
            }));
        }
        return null;
    } catch (error) {
        console.log({ error })
        return null;
    }
}

export const remove = (arr, value) => {
    var index = arr.indexOf(value);
    if (index > -1) {
        arr.splice(index, 1);
    }
    return arr;
}

export const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);

        fileReader.onload = () => {
            resolve(fileReader.result);
        };

        fileReader.onerror = (error) => {
            reject(error);
        };
    });
};

export const createImgUrl = (file) => file && URL.createObjectURL(file)

export const convertBlobToFile = (blob, name, type = "image/jpg") => new File([blob], name, { type, lastModified: new Date().getTime() })

export const convertFileToBlob = file => new Blob([JSON.stringify(file, null, 2)], {
    type: file.type,
});

export const isObject = A => (typeof A === "object" || typeof A === 'function') && (A !== null)
export const isObjectEmpty = A => isObject && !Object.keys(A).length

export const isChrome = () => {
    // Get the user-agent string
    let userAgentString =
        navigator.userAgent;

    // Detect Chrome
    let chromeAgent =
        userAgentString.indexOf("Chrome") > -1;

    if (chromeAgent)
        chromeAgent = true;

    return chromeAgent;
}

export const isSafari = () => {

    // Get the user-agent string
    let userAgentString =
        navigator.userAgent;

    // Detect Chrome
    let chromeAgent =
        userAgentString.indexOf("Chrome") > -1;

    let safariAgent =
        userAgentString.indexOf("Safari") > -1;

    // Discard Safari since it also matches Chrome
    if ((chromeAgent) && (safariAgent))
        safariAgent = false;

    return safariAgent;

    // return document.body.clientWidth < 576;
}

export function createMarkup(body, maxLength = 150) {
    let res = removeTags(body);
    res = res.trim();
    res = res.replace(/(\r\n|\n|\r)/gm, ""); //remove new line in body
    if (res.length > maxLength) {
        res = res.substring(0, maxLength).concat(' ...')
    }
    return res;
}

export const removeTags = (str) => {
    if (!str)// if null body, return blank
        return '';
    else
        str = str.toString();

    // Regular expression to identify HTML tags in 
    // the input string. Replacing the identified 
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/ig, '');
}

export const isJP = () => translations._language === 'jp';

export const getLanguageCode = () => isJP() ? "ja" : "en";

export function parseToExecutableHTML(rawString) {
    if (!rawString) {
        return null;
    }

    // Remove backslashes from the string
    const cleanString = rawString.replace(/\\/g, '');

    // Create a new temporary element
    const tempElement = document.createElement('div');
    tempElement.innerHTML = cleanString;

    // Get the content within the <pre> tag
    const preElement = tempElement.querySelector('pre');
    if (!preElement) {
        return tempElement?.innerHTML;
    }

    const preContent = preElement.textContent;

    // Create a new element to hold the parsed HTML
    const parsedElement = document.createElement('div');
    parsedElement.innerHTML = preContent;

    // Return the parsed HTML code
    return parsedElement.innerHTML;
}

export function extractTextFromTags(htmlString) {
    if (!htmlString) {
        return '';
    }

    // Remove style tags and their contents
    const cleanedString = htmlString.replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '');

    // Create a temporary element
    const tempElement = document.createElement('div');
    tempElement.innerHTML = cleanedString;

    // Select the desired tags
    const tagsToExtract = ['div', 'p'];

    // Set to store unique extracted text values
    const extractedTextSet = new Set();

    // Recursive function to traverse the DOM tree
    function traverse(element) {
        // If the current element is a desired tag, extract its text
        if (tagsToExtract.includes(element.tagName.toLowerCase())) {
            const text = element.textContent.trim();
            if (text) {
                extractedTextSet.add(text);
            }
        }

        // Traverse the child nodes
        const childNodes = element.childNodes;
        for (let i = 0; i < childNodes.length; i++) {
            const childNode = childNodes[i];
            if (childNode.nodeType === Node.ELEMENT_NODE) {
                traverse(childNode);
            }
        }
    }

    // Start traversing from the temporary element
    traverse(tempElement);

    // Convert the set to an array and join the extracted text values
    const extractedText = Array.from(extractedTextSet).join(', ');

    // Return the extracted text as a string
    return extractedText;
}

export const delay = (func, sec = 1000) => setTimeout(func, sec);

export const getNormalizedPath = (pathname) => {
    // Remove any query parameters
    const path = pathname.split('?')[0];

    const exactRoutes = [
        "/password-reset",
        "/password-reset/phone-verify",
        "/password-reset/set-password",
        "/change-email",
        "/register/idms/account-name",
        "/register/idms/profile-image",
        "/register/idms/email",
        "/register/idms/email-verify",
        "/register/idms/phone",
        "/register/idms/phone-verify",
        "/register/idms/password"
    ];
    if (exactRoutes.includes(path)) return path;
    
    if (/^\/login\/idms(\/[^/]+\/[^/]+)?$/.test(path)) return "/login/idms";
    if (/^\/logout\/idms(\/[^/]+\/[^/]+)?$/.test(path)) return "/logout/idms";
    if (/^\/register\/idms(\/[^/]+\/[^/]+)?$/.test(path)) return "/register/idms";

    return null;
};

const getLeviasAnalyticKey = (normalizedPath) => {
    let key = '';
    switch (normalizedPath) {
      case '/password-reset':
        key = 'is_reset_password';
        break;
      case '/password-reset/phone-verify':
        key = 'is_reset_password_otp';
        break;
      case '/password-reset/set-password':
        key = 'is_input_reset_password';
        break;
      case '/change-email':
        key = 'is_forgot_email';
        break;
      case '/register/idms/account-name':
        key = 'is_input_profile_name';
        break;
      case '/register/idms/profile-image':
        key = 'is_input_profile_image';
        break;
      case '/register/idms/email':
        key = 'is_input_email';
        break;
      case '/register/idms/email-verify':
        key = 'is_input_email_otp';
        break;
      case '/register/idms/phone':
        key = 'is_input_phone';
        break;
      case '/register/idms/phone-verify':
        key = 'is_input_phone_otp';
        break;
      case '/register/idms/password':
        key = 'is_input_password';
        break;
      case '/login/idms':
        key = 'is_view_login_page';
        break;
      case '/register/idms':
        key = 'is_view_register_page';
        break;
      default: break;
    }
    return key;
  };

export const sendReactGAPageView = async (pathname, referrer, title) => {
    const normalizedPath = getNormalizedPath(pathname);
    if (normalizedPath) {
        if (REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID) {
            const normalizedReferrer = getNormalizedPath(referrer || '');
            const option = {
                hitType: 'pageview',
                page: normalizedPath,
                page_location: window.location.origin + normalizedPath,
                page_path: normalizedPath,
            };
            if (normalizedReferrer) {
                option.page_referrer = window.location.origin + normalizedReferrer
            }
            if (title) {
                option.title = title;
            }
            ReactGA.send(option);
        }

        const leviasAnalyticKey = getLeviasAnalyticKey(normalizedPath);
        if (leviasAnalyticKey) {
            const url = getReferrerOrigin();
            await fetchCustomData(REACT_APP_CODE_D_MEASUREMENT_API_URL + 'levica-view-count', { [leviasAnalyticKey]: true, url }, 'POST');
        }
    }
}

export const isValidHttpUrl = (string) => {
    try {
        const newUrl = new URL(string);
        return newUrl.protocol === 'http:' || newUrl.protocol === 'https:';
    } catch (err) {
        return false;
    }
}

export const getReferrerOrigin = () => {
    let rParam = new URLSearchParams(window.location.search).get('r') ?? getRedirect();
    let referrerOrigin = null;

    if (rParam) {
        try {
            const referrerUrl = new URL(rParam);
            referrerOrigin = referrerUrl.origin;
        } catch (e) {
            console.error("Invalid URL found in 'r' parameter:", rParam, e);
            // Handle error, set a default origin or null if needed
        }
    }

    return referrerOrigin;
}
